import { AssessmentPresetDetailDto, CheckpointDetailDto, ConfiguredActionItemDto, TextBlockItemDto } from '@artemis-software/wr-api';
import { createForm } from '@sonofabit/ng-core';
import { Validators } from '@angular/forms';

export type CheckpointFormType = ReturnType<typeof createCheckpointForm>;
export type AssessmentPresetFormType = ReturnType<typeof createAssessmentPresetForm>;
export type TextBlockFormType = ReturnType<typeof createTextBlockForm>;

export const createCheckpointForm = (checkpoint?: CheckpointDetailDto)=> {
  return createForm(({ field, array }) => {
    return {
      id: field({ value: checkpoint?.id }),
      name: field({ value: checkpoint?.name, validators: [Validators.required] }),
      number: field({ value: checkpoint?.number, validators: [Validators.required] }),
      description: field({ value: checkpoint?.description, validators: [Validators.required] }),
      checkpointGroupId: field({ value: checkpoint?.checkpointGroup?.id, validators: [Validators.required] }),
      deprecated: field({ value: checkpoint?.deprecated }),
      buildingEquipmentRelated: field({ value: checkpoint?.buildingEquipmentRelated }),
      assessmentPresets: array([] as AssessmentPresetFormType[]),
      weight: field({
        value: checkpoint?.weight,
        validators: [Validators.required, Validators.min(0), Validators.max(10)]
      }),
      contractors: field({
        value: checkpoint?.contractors?.map(c => c.id) ?? [],
        toDto: value => value?.length ? value : undefined,
        alias: 'contractorIds',
      }),
    };
  });
};

export const createTextBlockForm = (textBlock?: TextBlockItemDto) => {
  return createForm(({ field }) => {
    return {
      id: field({ value: textBlock?.id }),
      text: field({ value: textBlock?.text ?? '', validators: [Validators.required] }),
    };
  });
};

export const createAssessmentPresetForm = (assessmentPreset?: AssessmentPresetDetailDto) => {
  const interval = AssessmentPresetDetailDto.CheckIntervalEnum;

  const form = createForm(({ field, array, mapToId }) => {
    return {
      id: field({ value: assessmentPreset?.id }),
      text: field({ value: assessmentPreset?.text ?? 'Neuer Text...' }),
      basis: field({ value: assessmentPreset?.basis }),
      referenceWork: field({ value: assessmentPreset?.referenceWork }),
      action: field({
        value: assessmentPreset?.action,
        toDto: value => value?.id,
        alias: 'actionId',
        validators: [Validators.required]
      }),
      checkpointId: field({ value: assessmentPreset?.checkpointId }),
      checkInterval: field({ value: assessmentPreset?.checkInterval ?? interval.None }),
      buildingEquipmentRelated: field({ value: assessmentPreset?.buildingEquipmentRelated ?? false }),
      standardAssessment: field({ value: assessmentPreset?.standardAssessment ?? false }),
      standardEquipment: field({
        value: assessmentPreset?.standardEquipment,
        toDto: value => value ? mapToId(value) : undefined,
        alias: 'standardEquipmentId',
      }),
      deprecated: field({ value: assessmentPreset?.deprecated ?? false }),
      textBlocks: array((assessmentPreset?.textBlocks ?? []).map((textBlock) => createTextBlockForm(textBlock))),
    };
  });
  form.controls.action.valueChanges.subscribe((action) => {
    if (action?.severity === ConfiguredActionItemDto.SeverityEnum.ImminentDanger) {
      form.controls.checkInterval.setValue(interval.TenDays);
      form.controls.checkInterval.disable();
    } else {
      form.controls.checkInterval.enable();
    }
  });
  return form;
};
